var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPath = function SvgPath(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "M8.973 3H3.84c-.568 0-1.027.447-1.027 1v2c0 .553.46 1 1.027 1h12.108a.52.52 0 0 0 .363-.147l1.54-1.5a.493.493 0 0 0 0-.706l-1.54-1.5A.52.52 0 0 0 15.948 3h-4.921c0-.553-.46-1-1.027-1-.568 0-1.027.447-1.027 1m8.214 7c0-.553-.46-1-1.027-1h-5.133V8H8.973v1H4.052a.52.52 0 0 0-.363.147l-1.54 1.5a.49.49 0 0 0 0 .706l1.54 1.5a.52.52 0 0 0 .363.147H16.16c.568 0 1.027-.447 1.027-1zm-6.16 7v-3H8.973v3c0 .553.46 1 1.027 1 .568 0 1.027-.447 1.027-1"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPath);
export default ForwardRef;